<header class="header header-8">
  <div class="branding">
    <a [routerLink]="defaultHomePageUrl" class="nav-link">
      <img class="logo" [src]="logo" alt="logo">
    </a>
  </div>
  <div class="header-nav" [clr-nav-level]="1">
    <table aria-describedby="navigation">
      <tr><th>
            <div class="header-title"><p>Data Collection & Information System</p></div>
      </th></tr>
      <tr><td>
        <clr-dropdown class="dropdown" *ngFor="let item of navbarMenuItems">
          <a (click)="!item.disabled && redirectToGivenPage(item.pageUrl)" class="nav-link"
            [class.active]="item.active" [class.disabled]="item.disabled"
            [style.display]="'inline-block'" clrDropdownTrigger>
            <span class="nav-text"> {{item.text}} </span>
          </a>
          <clr-dropdown-menu clrPosition="bottom-left" *ngIf="!item.pageUrl && item.dropdownItems">
            <div clrDropdownItem *ngFor="let ddItem of item.dropdownItems"
              [style.display]="checkLinkItem(ddItem.code) ? 'inline-block' : 'none'"
              (click)="redirectToGivenPage(ddItem.code)">{{ddItem.display}}</div>
          </clr-dropdown-menu>
          </clr-dropdown>
      </td></tr>
    </table>
  </div>
  <div class="header-actions" *ngIf="loggedIn" style="margin-top:0.5rem;">
    <clr-dropdown>
      <a class="nav-link nav-icon-text" clrDropdownTrigger>
        <div class="clr-row">
          <div class="clr-col-3">
            <clr-icon shape="user" class="user-icon is-solid"></clr-icon>
          </div>
          <div class="clr-col-9 pl-0 pt-1">
            <ul class="user-info list-unstyled">
              <li class="username"> {{username}}</li>
              <li>{{userRole}}</li>
              <li>{{facilityName | async}}</li>
            </ul>
          </div>
        </div>
      </a>
      <clr-dropdown-menu clrPosition="bottom-right">
        <div class="card dropdown-card">
          <div class="card-block" *ngIf="profilesList.length>1">
            <div class="profile-select">
              <div class="card-block">
                <button id="btn-switch-profile"  class="btn btn-link" routerLink="">Switch Profile</button>
              </div>
            </div>
          </div>
          <div class="card-block">
            <!-- # 3551 -->
            <button id="btn-logout" class="btn btn-link" routerLink="/login">Logout</button>
          </div>
        </div>
      </clr-dropdown-menu>
    </clr-dropdown>
  </div>
</header>